import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ForgotPasswordContainer } from './ForgotPassword.styled';
import { AuthFlowLayout } from 'components/v2/Layouts/AuthFlowLayout/AuthFlowLayout';
import { pageUrl } from 'utilities/pageUrl';

import { ForgotPasswordForm } from './ForgotPasswordForm';
import { FormType } from './ForgotPasswordForm.types';

export const ForgotPassword = () => {
  const [formType, setFormType] = useState<FormType>('request_code');
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryEmail = queryParams.get('email') || undefined;
  const isChangePasswordFlow = queryParams.get('flow') === 'change-password';

  const onGoBack = () => {
    window.scrollTo(0, 0);
    formType === 'request_code'
      ? navigate(pageUrl.login(), { replace: true })
      : setFormType('request_code');
  };

  return (
    <ForgotPasswordContainer>
      <AuthFlowLayout
        title={getTitle(formType, isChangePasswordFlow)}
        renderMainContent={() => {
          return (
            <ForgotPasswordForm
              onSuccessfulReset={() => navigate(pageUrl.login(), { replace: true })}
              onGoBack={onGoBack}
              handleUnconfirmed={email => {
                navigate(pageUrl.emailAddressVerification(), {
                  state: {
                    email,
                    forgotPassword: true
                  }
                });
              }}
              formType={formType}
              updateFormType={formType => setFormType(formType)}
              initialEmail={isChangePasswordFlow ? queryEmail : undefined}
              requestVerificationCodeDescription={
                isChangePasswordFlow
                  ? 'We will send a verification code to the email address on your account so you can change your password.'
                  : undefined
              }
              showLoaderDuringInitialRequest={isChangePasswordFlow}
            />
          );
        }}
      />
    </ForgotPasswordContainer>
  );
};

const getTitle = (formType: FormType, isChangePasswordFlow: boolean) => {
  if (formType === 'reset_password') return 'Create New Password';
  if (isChangePasswordFlow) return 'Change Your Password';

  return 'Forgot Your Password?';
};
